import {registerComponent} from '../utils/registry';

export default class Modal {
    private listeners: Array<{
        target: EventTarget,
        type: string,
        handler: EventListenerOrEventListenerObject,
    }> = [];

    public open(element: HTMLElement): void {
        if (element.classList.contains('show')) return;

        // Add backdrop
        const backdrop = document.createElement('div');
        backdrop.className = 'modal-backdrop fade show';
        document.body.appendChild(backdrop);

        document.body.classList.add('modal-open');
        element.style.display = 'block';
        void element.offsetHeight; // reflow for transition
        element.classList.add('show');
        element.setAttribute('aria-hidden', 'false');

        // Handle ESC key
        const escHandler = (e: KeyboardEvent) => {
            if (e.key === 'Escape') this.close(element);
        };
        this.addListener(document, 'keydown', escHandler)

        // Close buttons
        element.querySelectorAll('[data-dismiss="modal"]').forEach(btn =>
            this.addListener(btn, 'click', () => this.close(element))
        );

        // Close on backdrop click
        const backgroundClickHandler = (e: MouseEvent) => {
            // Only close if you clicked the overlay itself, not the dialog/content
            if (e.target === element) {
                this.close(element);
            }
        };
        this.addListener(element, 'click', backgroundClickHandler)
    }

    public close(element: HTMLElement): void {
        element.classList.remove('show');
        element.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('modal-open');

        // Remove backdrop
        document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());

        this.removeListeners();

        // Hide after transition
        setTimeout(() => {
            element.style.display = 'none';
        }, 150); // match Bootstrap’s fade duration
    }

    private addListener(
        target: EventTarget,
        type: string,
        handler: EventListenerOrEventListenerObject,
    ) {
        target.addEventListener(type, handler);
        this.listeners.push({target, type, handler})
    }

    private removeListeners(): void {
        for (const {target, type, handler} of this.listeners) {
            target.removeEventListener(type, handler);
        }

        this.listeners = [];
    }
}

const modal = new Modal();
registerComponent('modal', modal);
